import React from "react";
import Tooltip from "@mui/material/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { styled } from "@mui/material/styles";
import type { InfoTooltipProps } from "./types/types";

const StyledInfoIcon = styled(InfoOutlinedIcon)(({ theme }) => ({
  verticalAlign: "middle",
  transition: "color 0.2s, transform 0.2s",
  cursor: "pointer",
  borderRadius: "50%",
  "&:hover, &:focus": {
    color: "#1976d2",
    background: "#f0f6ff",
    transform: "scale(1.12)",
    outline: "none",
  },
  "&:focus-visible": {
    boxShadow: `0 0 0 2px ${theme.palette.primary.main}`,
  },
}));

const InfoTooltip: React.FC<InfoTooltipProps> = ({
  tooltip,
  iconProps,
  className = "",
  ...tooltipProps
}) => (
  <Tooltip title={tooltip} arrow placement="right" {...tooltipProps}>
    <span className={`align-middle ${className}`} tabIndex={0} aria-label="More info">
      <StyledInfoIcon {...iconProps} />
    </span>
  </Tooltip>
);

export default InfoTooltip;